<template>
  <div class="carteira-cadastro-campos-vue carteira-cadastros-vue mt-3">
    <div class="carteira-cadastros-vue__bootstrap-modals">
      <Modal
        modal-id="modalProdutosCamposPersonalizadosErro"
        :title="errorModalTitle"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="errorModalMessage" class="mb-2">{{ errorModalMessage }}</p>
          <ul
            v-if="errorModalItems.length"
            class="list-unstyled mb-0 carteira-cadastros-vue__error-list"
          >
            <li v-for="(row, i) in errorModalItems" :key="i" class="small">
              <template v-if="row.label">
                <strong>{{ row.label }}:</strong>
                {{ row.text }}
              </template>
              <template v-else>{{ row.text }}</template>
            </li>
          </ul>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeErrorModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalProdutosCamposPersonalizadosExcluir"
        title="Excluir registro"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="deleteTarget" class="mb-0">{{ deleteConfirmText }}</p>
        </template>
        <template #footer>
          <Button variant="danger" size="sm" :loading="deleteDeleting" @click="executeDeleteConfirmed">
            {{ deleteDeleting ? "Excluindo…" : "Excluir" }}
          </Button>
          <button
            type="button"
            class="btn btn-secondary btn-sm ml-2"
            :disabled="deleteDeleting"
            data-dismiss="modal"
            @click="closeDeleteConfirmModal"
          >
            Cancelar
          </button>
        </template>
      </Modal>

      <Modal
        modal-id="modalProdutosCamposPersonalizadosLog"
        title="Histórico de alterações"
        dialog-class="modal-xl"
      >
        <template #body>
          <div v-if="logLoading" class="text-center py-4">Carregando...</div>
          <div v-else-if="logHtml" class="produtos-campos-log-html" v-html="logHtml"></div>
          <p v-else class="mb-0 text-muted">Nenhum log para exibir.</p>
        </template>
        <template #footer>
          <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
        </template>
      </Modal>

      <Modal modal-id="modalProdutosCamposPersonalizadosItem" :title="modalTitle" dialog-class="modal-lg">
        <template #body>
          <Input
            v-model="form.nome"
            name="nome"
            id="produto-campo-personalizado-nome"
            label="Nome"
            placeholder="Nome"
            required
          />
          <div class="mb-3">
            <label class="form-label d-block">Tipo</label>
            <select
              v-model.number="form.tipo"
              class="form-control form-control-sm"
              :disabled="!!editingId"
            >
              <option v-for="opt in tipoOpcoes" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
            <small v-if="editingId" class="text-muted">O tipo não pode ser alterado após a criação.</small>
          </div>
          <div v-if="form.tipo === TIPO_TEXTO" class="mb-3">
            <Check v-model="form.texto_area">Usar área de texto (textarea)</Check>
            <small class="text-muted d-block">Desmarcado: campo de texto em uma linha.</small>
          </div>
          <div v-if="form.tipo === TIPO_LISTA" class="mb-3">
            <label class="form-label d-block">Opções da lista</label>
            <div v-for="(opcao, idx) in form.conteudo" :key="idx" class="d-flex mb-2">
              <input
                v-model="form.conteudo[idx]"
                type="text"
                class="form-control form-control-sm mr-2"
                placeholder="Opção"
              />
              <button type="button" class="btn btn-outline-danger btn-sm" @click="removeOpcao(idx)">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="addOpcao">
              <i class="fas fa-plus mr-1"></i> Adicionar opção
            </button>
          </div>
          <Input
            v-model="form.external_id"
            name="external_id"
            id="produto-campo-personalizado-external-id"
            label="External ID"
            placeholder="Identificador externo (opcional)"
          />
          <Input
            v-model="ordemStr"
            name="ordem"
            id="produto-campo-personalizado-ordem"
            label="Ordem"
            type="number"
            placeholder="Sequência de exibição"
          />
          <div class="mb-2">
            <Check v-model="form.ativo">Ativo</Check>
          </div>
          <p v-if="formError" class="text-danger small mb-0">{{ formError }}</p>
        </template>
        <template #footer>
          <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
          <Button variant="primary" size="sm" :loading="saving" @click="saveModal">Salvar</Button>
        </template>
      </Modal>
    </div>

    <div v-if="!localUsuarioPodeCadastro" class="alert alert-warning">
      Somente administradores ou gerentes podem gerenciar estes cadastros.
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap carteira-cadastros-vue__toolbar">
      <h5 class="mb-0"></h5>
      <Button
        v-if="localUsuarioPodeCadastro"
        variant="success"
        size="sm"
        depth
        @click="openEditModal(null)"
      >
        <Icon type="fas" icon="plus" color="white" class="mr-1" />
        Adicionar
      </Button>
    </div>

    <div v-if="loading" class="text-center py-4">Carregando...</div>
    <div v-else class="carteira-cadastros-vue__card carteira-cadastros-vue__datatable-wrap">
      <DataTable
        name="ProdutosCamposPersonalizados"
        :headers="headers"
        :data="items"
        :pesquisa="true"
        :options="tableOptions"
        :itens-per-page-options="[10, 20, 30, 50, 100, -1]"
      >
        <template v-slot:[`item.tipo`]="{ item }">
          {{ tipoLabel(item.tipo) }}
        </template>
        <template v-slot:[`item.conteudo`]="{ item }">
          <ol v-if="Array.isArray(item.conteudo) && item.conteudo.length" class="pl-3 mb-0">
            <li v-for="(opt, i) in item.conteudo" :key="i">{{ opt }}</li>
          </ol>
          <span v-else>—</span>
        </template>
        <template v-slot:[`item.external_id`]="{ item }">
          {{ item.external_id || "—" }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <span
            class="campanha-interna-vue-status-pill"
            :class="
              isAtivo(item)
                ? 'campanha-interna-vue-status-pill--ativa'
                : 'campanha-interna-vue-status-pill--inativa'
            "
          >
            {{ isAtivo(item) ? "Ativo" : "Inativo" }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-content-end align-items-center flex-wrap carteira-cadastros-vue__row-actions">
            <Button
              variant="secondary"
              size="sm"
              table
              class="mr-1 mb-1"
              title="Log"
              @click="openLogModal(item)"
            >
              <i class="fas fa-history"></i>
            </Button>
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="primary"
              size="sm"
              table
              class="mr-1 mb-1"
              title="Editar"
              @click="openEditModal(item)"
            >
              <i class="fas fa-edit"></i>
            </Button>
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="danger"
              size="sm"
              table
              class="mb-1"
              title="Excluir"
              @click="openDeleteConfirmModal(item)"
            >
              <i class="fas fa-trash"></i>
            </Button>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "../ui/DataTable.vue";
import Input from "../ui/Input.vue";
import Check from "../ui/Check.vue";
import Icon from "../ui/Icon.vue";
import Button from "../ui/Button.vue";
import Modal from "../ui/Modal.vue";

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

const TIPO_TEXTO = 1;
const TIPO_LISTA = 2;
const TIPO_NUMERICO = 3;
const TIPO_DATA = 4;

function fieldLabel(key) {
  const map = {
    nome: "Nome",
    tipo: "Tipo",
    ordem: "Ordem",
    ativo: "Ativo",
    external_id: "External ID",
    texto_area: "Área de texto",
    conteudo: "Opções",
  };
  return map[key] || String(key).replace(/_/g, " ");
}

function bs$(selector) {
  const jq = typeof window !== "undefined" ? window.jQuery || window.$ : null;
  if (!jq) {
    return { modal: () => {} };
  }
  return jq(selector);
}

export default {
  name: "ProdutosCamposPersonalizadosCadastroApp",
  components: { DataTable, Input, Check, Icon, Button, Modal },
  data() {
    return {
      TIPO_TEXTO,
      TIPO_LISTA,
      localApiUrls: {},
      localUsuarioPodeCadastro: false,
      items: [],
      loading: false,
      saving: false,
      tableOptions: { page: 1, itemsPerPage: 30 },
      editingId: null,
      form: {
        nome: "",
        tipo: TIPO_TEXTO,
        conteudo: [],
        ordem: null,
        ativo: true,
        external_id: "",
        texto_area: false,
      },
      formError: "",
      errorModalTitle: "Atenção",
      errorModalMessage: "",
      errorModalItems: [],
      deleteTarget: null,
      deleteDeleting: false,
      tipoOpcoes: [
        { value: TIPO_TEXTO, label: "Texto" },
        { value: TIPO_LISTA, label: "Lista" },
        { value: TIPO_NUMERICO, label: "Numérico" },
        { value: TIPO_DATA, label: "Data" },
      ],
      headers: [
        { text: "#", value: "id", sortable: true, width: "72px" },
        { text: "Nome", value: "nome", sortable: true },
        { text: "Tipo", value: "tipo", sortable: true },
        { text: "Opções", value: "conteudo", sortable: false },
        { text: "Ordem", value: "ordem", sortable: true },
        { text: "External ID", value: "external_id", sortable: true },
        { text: "Ativo", value: "ativo", sortable: true },
        { text: "Ações", value: "actions", sortable: false, align: "end", width: "156px" },
      ],
      logFeature: "",
      logIndexUrl: "",
      logLoading: false,
      logHtml: "",
    };
  },
  computed: {
    modalTitle() {
      return `${this.editingId ? "Editar" : "Novo"} campo personalizado de produto`;
    },
    ordemStr: {
      get() {
        const o = this.form.ordem;
        if (o === null || o === undefined || o === "") return "";
        return String(o);
      },
      set(v) {
        if (v === "" || v === null || v === undefined) {
          this.form.ordem = null;
          return;
        }
        const n = Number(v);
        this.form.ordem = Number.isNaN(n) ? null : n;
      },
    },
    deleteConfirmText() {
      if (!this.deleteTarget) return "";
      const nome = this.deleteTarget.nome || `#${this.deleteTarget.id}`;
      return `Excluir o campo "${nome}"? Esta ação não pode ser desfeita.`;
    },
  },
  mounted() {
    const cfg =
      typeof window !== "undefined" ? window.produtoCamposPersonalizadosCadastroConfig || {} : {};
    this.localApiUrls = cfg.apiUrls && Object.keys(cfg.apiUrls).length ? cfg.apiUrls : {};
    axios.defaults.headers.common["X-CSRF-TOKEN"] = cfg.csrfToken || "";
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    this.localUsuarioPodeCadastro =
      cfg.usuarioPodeCadastro !== undefined ? !!cfg.usuarioPodeCadastro : false;
    this.logFeature = cfg.logFeature || "produtos-campos-personalizados";
    this.logIndexUrl = cfg.logIndexUrl || "";
    this.loadList();
  },
  methods: {
    async openLogModal(item) {
      if (!item || !this.logIndexUrl) {
        return;
      }
      this.logLoading = true;
      this.logHtml = "";
      this.$nextTick(() => bs$("#modalProdutosCamposPersonalizadosLog").modal("show"));
      try {
        const { data } = await axios.get(this.logIndexUrl, {
          params: {
            log: 1,
            feature: this.logFeature,
            id: item.id,
          },
          headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
          responseType: "text",
          transformResponse: [(r) => r],
        });
        this.logHtml = typeof data === "string" ? data : String(data);
      } catch (e) {
        this.logHtml = "<p class=\"text-danger mb-0\">Não foi possível carregar o histórico.</p>";
      } finally {
        this.logLoading = false;
      }
    },
    tipoLabel(tipo) {
      const n = Number(tipo);
      const found = this.tipoOpcoes.find((o) => o.value === n);
      return found ? found.label : String(tipo);
    },
    isAtivo(item) {
      const s = item && item.ativo;
      if (s === true || s === 1 || s === "1") return true;
      if (s === false || s === 0 || s === "0") return false;
      return !!s;
    },
    addOpcao() {
      this.form.conteudo = [...(this.form.conteudo || []), ""];
    },
    removeOpcao(idx) {
      this.form.conteudo = (this.form.conteudo || []).filter((_, i) => i !== idx);
    },
    showErrorModal({ title, message, errors }) {
      this.errorModalTitle = title || "Atenção";
      this.errorModalMessage = message || "";
      this.errorModalItems = [];
      if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = fieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== "") {
              this.errorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.errorModalMessage && this.errorModalItems.length) {
        this.errorModalMessage = "Corrija os campos indicados abaixo.";
      }
      this.$nextTick(() => bs$("#modalProdutosCamposPersonalizadosErro").modal("show"));
    },
    closeErrorModal() {
      bs$("#modalProdutosCamposPersonalizadosErro").modal("hide");
    },
    openDeleteConfirmModal(item) {
      this.deleteTarget = item;
      this.deleteDeleting = false;
      this.$nextTick(() => bs$("#modalProdutosCamposPersonalizadosExcluir").modal("show"));
    },
    closeDeleteConfirmModal() {
      bs$("#modalProdutosCamposPersonalizadosExcluir").modal("hide");
      this.deleteTarget = null;
    },
    async loadList() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.localApiUrls.camposPersonalizados, {
          headers: JSON_HEADERS,
        });
        this.items = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error(e);
        this.items = [];
        this.showErrorModal({ title: "Lista", message: "Não foi possível carregar os dados." });
      } finally {
        this.loading = false;
      }
    },
    openEditModal(row) {
      this.formError = "";
      this.editingId = row ? row.id : null;
      this.form = {
        nome: row ? row.nome : "",
        tipo: row ? Number(row.tipo) : TIPO_TEXTO,
        conteudo: row && Array.isArray(row.conteudo) ? [...row.conteudo] : [],
        ordem: row ? row.ordem : null,
        ativo: row ? this.isAtivo(row) : true,
        external_id: row && row.external_id ? String(row.external_id) : "",
        texto_area: row ? !!row.texto_area : false,
      };
      this.$nextTick(() => bs$("#modalProdutosCamposPersonalizadosItem").modal("show"));
    },
    async saveModal() {
      this.formError = "";
      this.saving = true;
      try {
        const payload = {
          nome: this.form.nome,
          tipo: Number(this.form.tipo),
          conteudo: Number(this.form.tipo) === TIPO_LISTA ? this.form.conteudo : null,
          ordem:
            this.form.ordem === null || this.form.ordem === "" ? null : Number(this.form.ordem),
          ativo: !!this.form.ativo,
          external_id: this.form.external_id ? String(this.form.external_id).trim() : null,
          texto_area:
            Number(this.form.tipo) === TIPO_TEXTO ? !!this.form.texto_area : false,
        };
        const base = this.localApiUrls.campoPersonalizadoBase;
        if (this.editingId) {
          await axios.put(`${base}/${this.editingId}`, payload, { headers: JSON_HEADERS });
        } else {
          await axios.post(base, payload, { headers: JSON_HEADERS });
        }
        bs$("#modalProdutosCamposPersonalizadosItem").modal("hide");
        await this.loadList();
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          this.showErrorModal({
            title: "Dados inválidos",
            message: d.message || "Os dados enviados são inválidos.",
            errors: d.errors,
          });
        } else {
          const msg =
            (typeof d.message === "string" && d.message) ||
            (typeof d.error === "string" && d.error) ||
            "Não foi possível salvar.";
          this.formError = typeof msg === "string" ? msg : JSON.stringify(msg);
        }
      } finally {
        this.saving = false;
      }
    },
    async executeDeleteConfirmed() {
      if (!this.deleteTarget) {
        this.closeDeleteConfirmModal();
        return;
      }
      const id = this.deleteTarget.id;
      this.deleteDeleting = true;
      try {
        await axios.delete(`${this.localApiUrls.campoPersonalizadoBase}/${id}`, {
          headers: JSON_HEADERS,
        });
        this.closeDeleteConfirmModal();
        await this.loadList();
      } catch (e) {
        this.closeDeleteConfirmModal();
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: "Exclusão",
          message:
            (typeof d.message === "string" && d.message) || "Não foi possível excluir este registro.",
        });
      } finally {
        this.deleteDeleting = false;
      }
    },
  },
};
</script>

<style scoped>
.carteira-cadastros-vue__toolbar {
  gap: 0.5rem;
}

.carteira-cadastros-vue__error-list li + li {
  margin-top: 0.35rem;
}

.carteira-cadastros-vue__datatable-wrap ::v-deep .container-fluid {
  padding-left: 0;
  padding-right: 0;
}
</style>
